import { createResourceApi } from 'resources/ResourceApi';
import { LocaleApiItem } from 'typings/api';

export default createResourceApi<LocaleApiItem>('locales');
